import React from 'react';
import { ScaleIcon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SolutionOverview() {
  return <section className="bg-accent px-5 py-10 text-ink md:px-8" data-id="element-188" data-mp="3jw84dmgw05kq">
      <FadeIn className="mx-auto flex max-w-4xl flex-col items-center text-center" data-id="element-189" data-mp="3evk5yfqbwmgh">
        <ScaleIcon size={33} strokeWidth={1.6} aria-hidden="true" data-id="element-190" data-mp="3au8kmmehmne3" />
        <h2 className="mt-3 font-display text-2xl font-bold md:text-3xl" data-id="element-191" data-mp="3atyvt256im9z">
          Una obra práctica desarrollada por abogados para abogados.
        </h2>
        <p className="mt-2 max-w-2xl text-sm font-medium leading-relaxed md:text-base" data-id="element-192" data-mp="3145inwpe1z3m">
          Modelos, fundamentos y estrategias concebidos para acompañar la
          resolución diaria de expedientes laborales.
        </p>
      </FadeIn>
    </section>;
}